import { GlobalState } from '../../actions';

const sqlStatisticSelector = (state: GlobalState) => state.sqlStatistics;

export const sqlStatisticServerSelector = (state: GlobalState, serverName: string) =>
    sqlStatisticSelector(state)[serverName];

export const sqlStatisticsServerAvailableSelector = (state: GlobalState, serverName: string) => {
    const s = sqlStatisticServerSelector(state, serverName);
    return s ? s.serverAvailable : null;
};

export const sqlStatisticsStatsSelector = (state: GlobalState, serverName: string) => {
    const s = sqlStatisticServerSelector(state, serverName);
    return s ? s.stats : null;
};
